import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CatchingPokemonIcon(props: IconProps) {
    return <Icon {...props} iconKey={"catching_pokemon"}/>
}
